__turbopack_context__.v({
  "className": "bRyC9W_className",
  "variable": "bRyC9W_variable",
});
